import ChangeOrderDocument from '../../services/changeOrderDocument'
import * as types from '../mutationTypes'

let state = {
  error: null,
  status: null,
  documents: [],
  documentsByChangeOrder: [],
  headers: [
    { text: 'Id', value: 'id' },
    { text: 'File Name', value: 'fileName' },
    { text: 'Description', value: 'description' },
    { text: 'Actions', value: 'action', sortable: false }
  ]

}

const getters = {
  error (state) {
    return state.error
  },
  status (state) {
    return state.status
  },
  documents (state) {
    return state.documents
  },
  documentsByChangeOrder (state) {
    return state.documentsByChangeOrder
  },
  headers () {
    return state.headers
  }
}

const actions = {
  async loadAll ({ commit, dispatch }, limit, offset) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await ChangeOrderDocument.getAll(limit, offset)
      if (res) {
        commit(types.REQUEST_GET_ALL_CHANGE_ORDER_DOCUMENTS_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_GET_ALL_CHANGE_ORDER_DOCUMENTS_ERROR, err)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async loadByChangeOrder ({ commit, dispatch }, changeOrderId) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await ChangeOrderDocument.getByChangeOrder(changeOrderId)
      if (res) {
        commit(types.REQUEST_GET_CHANGE_ORDER_DOCUMENTS_BY_CHANGE_ORDER_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_GET_CHANGE_ORDER_DOCUMENTS_BY_CHANGE_ORDER_ERROR, err)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async getFile ({ commit, dispatch }, data) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      const document = data
      // If the document is a PDF it can be opened in a new window for viewing
      // otherwise it will auto download
      if (document.fileName.endsWith('.pdf')) {
        let res = await ChangeOrderDocument.getUrl(document.id)
        if (res) {
          let win = window.open(res.data, '_blank')
          win.focus()
        }
      } else {
        let res = await ChangeOrderDocument.getFile(document.id)
        if (res) {
          const file = new Blob([res.data], { type: res.headers['content-type'] })
          let link = window.document.createElement('a')
          link.href = window.URL.createObjectURL(file)
          link.download = data.fileName
          link.click()
        }
        commit(types.REQUEST_GET_CHANGE_ORDER_DOCUMENT_SUCCESS)
      }
    } catch (err) {
      commit(types.REQUEST_GET_CHANGE_ORDER_DOCUMENT_ERROR, err)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async uploadCreate ({ commit, dispatch }, data) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await ChangeOrderDocument.uploadCreate(data)
      if (res) {
        commit(types.REQUEST_CREATE_UPLOAD_CHANGE_ORDER_DOCUMENT_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_CREATE_UPLOAD_CHANGE_ORDER_DOCUMENT_ERROR, err)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async update ({ commit, dispatch }, document) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await ChangeOrderDocument.update(document)
      if (res) {
        commit(types.REQUEST_UPDATE_CHANGE_ORDER_DOCUMENT_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_UPDATE_CHANGE_ORDER_DOCUMENT_ERROR, err)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async delete ({ commit, dispatch }, id) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await ChangeOrderDocument.delete(id)
      if (res) {
        commit(types.REQUEST_DELETE_CHANGE_ORDER_DOCUMENT_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_DELETE_CHANGE_ORDER_DOCUMENT_ERROR, err)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  clearErrors ({ commit }) {
    commit(types.CLEAR_ERROR_CHANGE_DOCUMENT)
  }
}

const mutations = {
  [types.REQUEST_GET_ALL_CHANGE_ORDER_DOCUMENTS_SUCCESS] (state, data) {
    state.error = null
    state.status = 'Success'
    state.documents = data
  },
  [types.REQUEST_GET_ALL_CHANGE_ORDER_DOCUMENTS_ERROR] (state, error) {
    state.error = error
    state.status = null
    state.documents = []
  },
  [types.REQUEST_GET_CHANGE_ORDER_DOCUMENTS_BY_CHANGE_ORDER_SUCCESS] (state, data) {
    state.error = null
    state.status = 'Success'
    state.documentsByChangeOrder = data
  },
  [types.REQUEST_GET_CHANGE_ORDER_DOCUMENTS_BY_CHANGE_ORDER_ERROR] (state, error) {
    state.error = error
    state.status = null
    state.documentsByChangeOrder = []
  },
  [types.REQUEST_GET_CHANGE_ORDER_DOCUMENT_SUCCESS] (state) {
    state.error = null
    state.status = 'Success'
  },
  [types.REQUEST_GET_CHANGE_ORDER_DOCUMENT_ERROR] (state, error) {
    state.error = error
    state.status = null
  },
  [types.REQUEST_CREATE_UPLOAD_CHANGE_ORDER_DOCUMENT_SUCCESS] (state, data) {
    state.error = null
    state.status = 'Success'
  },
  [types.REQUEST_CREATE_UPLOAD_CHANGE_ORDER_DOCUMENT_ERROR] (state, error) {
    state.error = error
    state.status = null
  },
  [types.REQUEST_UPDATE_CHANGE_ORDER_DOCUMENT_SUCCESS] (state, data) {
    state.error = null
    state.status = 'Success'
  },
  [types.REQUEST_UPDATE_CHANGE_ORDER_DOCUMENT_ERROR] (state, error) {
    state.error = error
    state.status = null
    // Dont update document object in state
  },
  [types.REQUEST_DELETE_CHANGE_ORDER_DOCUMENT_SUCCESS] (state, data) {
    state.error = null
    state.status = 'Success'
    state.document = null // removed object
  },
  [types.REQUEST_DELETE_CHANGE_ORDER_DOCUMENT_ERROR] (state, error) {
    state.error = error
    state.status = null
    // Dont update document object in state
  },
  [types.CLEAR_ERROR_CHANGE_DOCUMENT] (state) {
    state.error = null
    state.status = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
